import { QuestionCircleOutlined } from '@ant-design/icons';
import {
    Form,
    Select,
    Button,
    ConfigProvider,
    Row,
    Col,
    Input,
    Space,
    Modal
} from 'antd';
import 'antd/dist/antd.css';
import axios from '../../utils/request';
import React, { Component } from 'react';
import { Spinner } from 'reactstrap';

const { Option } = Select;
let tenantId = "";
let errorMessage = "";
let commonParamater = "";
let formRef;
let stfName = "";
let stfCode = "";

const formLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};

export class DongFangXiWang extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isReady: false,
            isLoading: true,
            isSuccess: false,
            errorMessage: "",
            reqNos: [],
            personIds: "",
            tenantId: "",
            userId: "",
            reqNo: "",
            staffName: "",
            staffNo: "",
            stfName: "",
            stfCode: "",
            commonParamater: ""
        }
    };

    formRef = React.createRef();

    componentDidMount() {
        const urlParams = new URLSearchParams(window.location.search);
        let commonParamater = urlParams.get("commonParamater");
        tenantId = urlParams.get("tenantId");
        let messageCode = urlParams.get("messageCode");
        // if (!commonParamater) {
        //     this.setState({ errorMessage: "commonParamater不存在！", isLoading: false, isReady: true });
        //     return;
        // }
        //console.log("标准系统参数", commonParamater, tenantId);

        this.state.commonParamater = commonParamater;
        this.state.tenantId = tenantId;
        this.loadPage(tenantId, commonParamater);
        //this.loadPage(430585, "1246375d-34e8-4a0d-897d-613010ccf01d");
        //this.setState({ isLoading: false, isReady: true, errorMessage: "" });
    };

    loadPage = (tenantId, commonParamater) => {
        const params = {
            tenantId,
            commonParamater
        }

        //东方希望需求 https://service-bridge.recruit.italent.cn
        axios
            .get("/api/DongFangXiWang/GetRequirements", { params: params })
            .then(res => {
                //console.log("雨虹需求", res);
                let errorMessage = "";

                if (res.status == 200 && res.data.code == "200") {
                    this.setState({
                        reqNos: res.data.data
                    });
                }
                else {
                    errorMessage = "获取东方希望需求ID失败";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }

                this.setState({ isLoading: false, isReady: true, errorMessage });
            })
            .catch(reason => {
                //console.log(reason);
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
        );


    };

    onFinish = async (values) => {
        const fieldsValue = await this.formRef.current.validateFields();
        console.log(fieldsValue);
        const params = {
            tenantId: this.state.tenantId,
            commonParamater: this.state.commonParamater,
            reqCode: fieldsValue.reqCode,
        };
        console.log(params);
        const bodyString = JSON.stringify(params);
        axios
            .post("/api/DongFangXiWang/AddRequirementToApply", bodyString,
                {
                    headers: { "Content-Type": "application/json" }
                })
            .then(res => {
                //console.log("保存雨虹需求ID", res);
                let errorMessage = "";
                if (res.status == 200 && res.data.code == "200") {                  
                    this.setState({ isLoading: false, isReady: true, isSuccess: true });
                }
                else {
                    errorMessage = "绑定招聘需求异常，请联系管理员！";
                    this.setState({ isLoading: false, isReady: true, errorMessage });
                }
            })
            .catch(reason => {
                this.setState({ isLoading: false, isReady: true, errorMessage: "操作异常，请联系管理员！" });
            })
            .finally(
        );
    };

    render() {
        if (this.state.isReady) {
            if (this.state.errorMessage !== "") {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "red" }}>{this.state.errorMessage}</span></div>)
            }
            if (this.state.isSuccess) {
                return (<div style={{ textAlign: "center", padding: "32px" }}><span style={{ color: "green" }}>绑定招聘需要求成功</span></div>)
            }
            else {
                return (
                    <ConfigProvider>
                        <div className="xwd-wrap">
                            <div
                                className="header"
                                orientation="left"
                                style={{ fontSize: "18px" }}
                            >
                                绑定招聘需求
                            </div>
                            <Form className="content" onFinish={this.onFinish} ref={this.formRef} {...formLayout}>
                                <Form.Item
                                    name="reqCode"
                                    label={<>
                                        <span>招聘需求</span>
                                        {/*<Tooltip title="若是后增加的需求请将候选人转移一下状态，以便获取到新的雨虹需求ID">*/}
                                        {/*    <span style={{ marginTop: '-4px', paddingLeft: '4px', paddingRight: '6px' }}><QuestionCircleOutlined /></span>*/}
                                        {/*</Tooltip>*/}
                                    </>}
                                    required
                                    rules={[
                                        {
                                            required: true,
                                            message: '请选择招聘需求',
                                        },
                                    ]}
                                >
                                    <Select showSearch
                                        placeholder="---请选择招聘需求---"
                                    >
                                        {this.state.reqNos.map((opt) => (
                                            <Option key={opt.code}>{opt.name}</Option>
                                        ))}
                                    </Select>

                                </Form.Item>
                                <Form.Item>

                                </Form.Item>
                                <div className="footer">
                                    <Space>
                                        <Button type="prmary" htmlType="submit">保存</Button>
                                    </Space>
                                </div>
                            </Form>
                        </div>
                    </ConfigProvider>
                )
            }
        }
        else {
            return (
                <div style={{ textAlign: "center", lineHeight: "100vh" }}>
                    <Spinner type="grow" color="primary" />
                    <Spinner type="grow" color="secondary" />
                    <Spinner type="grow" color="success" />
                    <Spinner type="grow" color="danger" />
                    <Spinner type="grow" color="warning" />
                    <Spinner type="grow" color="info" />
                    <Spinner type="grow" color="dark" />
                </div>
            );
        }
    }
}